const types = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",

  STORE_ADMINS: "STORE_ADMINS",
  CREATE_ADMIN: "CREATE_ADMIN",
  EDIT_ADMIN: "EDIT_ADMIN",
  DESTROY_ADMIN: "DESTROY_ADMIN",

  STORE_CATEGORIES: "STORE_CATEGORIES",
  CREATE_CATEGORY: "CREATE_CATEGORY",
  EDIT_CATEGORY: "EDIT_CATEGORY",
  DESTROY_CATEGORY: "DESTROY_CATEGORY",

  STORE_PRODUCTS: "STORE_PRODUCTS",
  CREATE_PRODUCT: "CREATE_PRODUCT",
  EDIT_PRODUCT: "EDIT_PRODUCT",
  DESTROY_PRODUCT: "DESTROY_PRODUCT",

  STORE_ORDERS: "STORE_ORDERS",
  CREATE_ORDER: "CREATE_ORDER",
  EDIT_ORDER: "EDIT_ORDER",
  DESTROY_ORDER: "DESTROY_ORDER",

  STORE_CUSTOMERS: "STORE_CUSTOMERS",
  CREATE_CUSTOMER: "CREATE_CUSTOMER",
  EDIT_CUSTOMER: "EDIT_CUSTOMER",
  DESTROY_CUSTOMER: "DESTROY_CUSTOMER",
  SEARCH_CUSTOMER: "SEARCH_CUSTOMER",
};

export default types;
